import { t } from '@base/utils/helpers';
import React, { useEffect, useRef, useState } from 'react';
import { Talk } from '../../../model/interfaces';
import styles from './challengeChat.module.scss';

export default function ChallengeChat(props: {
  send?: (message: string) => void;
  messages: Talk[];
}) {
  const wrapper = useRef<HTMLUListElement>(null);
  const [message, setMessage] = useState('');

  function handleSend(e: React.FormEvent) {
    e.preventDefault();
    props.send?.(message);
    setMessage('');
  }

  useEffect(() => {
    if (!wrapper.current) return;
    wrapper.current.scrollTop = wrapper.current.scrollHeight;
  }, [props.messages]);

  return (
    <div className={styles.chat}>
      <div className={styles.messages}>
        <ul ref={wrapper}>
          {props.messages.map(
            (m, index) =>
              m.text !== 'null' && (
                <li key={index}>
                  {m.from} [{m.time}]: {m.text}
                </li>
              )
          )}
        </ul>
      </div>
      {props.send && (
        <footer>
          <form onSubmit={handleSend}>
            <input
              onChange={(e) => setMessage(e.target.value)}
              value={message}
              placeholder="Input your message here..."
            ></input>
            <button type="submit">{t('send')}</button>
          </form>
        </footer>
      )}
    </div>
  );
}
